import * as React from 'react';
import * as Yup from 'yup';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Button } from 'Src/components/Button/Button';
import { ProductType } from '../../../../../../../models/productTypes';

interface Props {
  onCancel: () => void;
  onSubmit: (data) => void;
  productType?: ProductType;
}

const ProductTypeSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  order: Yup.number()
    .required('Required')
    .min(0, 'Order must be a positive number'), // Add validation for the order field
});

export function ProductTypeForm(props: Props) {
  const { productType, onSubmit, onCancel } = props;
  const isProductTypeExist = typeof productType !== 'undefined';
  const productTypeForm = {
    name: isProductTypeExist ? productType.name : '',
    order: isProductTypeExist ? productType.order : 0,
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <Formik initialValues={productTypeForm} validationSchema={ProductTypeSchema} onSubmit={onSubmit}>
            {({ touched, errors, handleSubmit }) => (
              <Form>
                <div className="form-group form-check">
                  <div className="form-group">
                    <label>Product Type Name</label>
                    <Field name="name" className="form-control mb-3" />
                    <ErrorMessage component="div" className="alert alert-danger" name="name" />
                  </div>

                  <div className="form-group">
                    <label>Order</label>
                    <Field name="order" type="number" className="form-control mb-3" />
                    <ErrorMessage component="div" className="alert alert-danger" name="order" />
                  </div>

                  <Button
                    onClick={onCancel}
                    text={'Cancel'}
                    customClass={'btn btn-primary mt-3 mb-3 mr-3 btn-secondary'}
                  />
                  <Button
                    onClick={handleSubmit}
                    text={'Save'}
                    customClass={'mt-3 mb-3 btn btn-primary'}
                    type={'submit'}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}
